(() => {
  const SECTION_SELECTOR = '.starina-quem-somos-section';
  const PRE_TRIGGER = 0.2; // 20%
  const SMOOTHING = 0.1;
  const SNAP = 0.001;
  const OFFSET = 90;

  const MEDIA_CONFIG = [
    { selector: '.starina-quem-somos__media--1', startX: OFFSET },
    { selector: '.starina-quem-somos__media--2', startX: -OFFSET },
    { selector: '.starina-quem-somos__media--3', startX: -OFFSET },
    { selector: '.starina-quem-somos__media--4', startX: OFFSET }
  ];

  const sections = document.querySelectorAll(SECTION_SELECTOR);
  if (!sections.length) return;

  const clamp = (value, min = 0, max = 1) => Math.min(Math.max(value, min), max);

  function getMediaElement(wrapper) {
    if (!wrapper) return null;

    return (
      wrapper.querySelector('.starina-quem-somos__frame > :where(img,video,svg)') ||
      wrapper.querySelector('.starina-quem-somos__frame :where(img,video,svg)')
    );
  }

  function getDownProgress(rect, viewportHeight) {
    const triggerOffset = viewportHeight * PRE_TRIGGER;
    const startTop = viewportHeight + triggerOffset;
    const endTop = viewportHeight - rect.height;

    if (startTop === endTop) {
      return rect.top <= endTop ? 1 : 0;
    }

    return clamp((startTop - rect.top) / (startTop - endTop));
  }

  function getUpProgress(rect, viewportHeight) {
    const triggerOffset = viewportHeight * PRE_TRIGGER;
    const startTop = (viewportHeight - triggerOffset) - rect.height;
    const endTop = viewportHeight;

    if (startTop === endTop) {
      return rect.top < endTop ? 1 : 0;
    }

    return 1 - clamp((rect.top - startTop) / (endTop - startTop));
  }

  function getInitialProgress(rect, viewportHeight) {
    return Math.max(
      getDownProgress(rect, viewportHeight),
      getUpProgress(rect, viewportHeight)
    );
  }

  const items = [];

  sections.forEach((section) => {
    MEDIA_CONFIG.forEach(({ selector, startX }) => {
      const wrapper = section.querySelector(selector);
      const media = getMediaElement(wrapper);

      if (!wrapper || !media) return;

      items.push({
        wrapper,
        media,
        startX,
        current: 0,
        target: 0
      });
    });
  });

  if (!items.length) return;

  let lastScrollY = window.pageYOffset || window.scrollY || 0;
  let scrollDirection = 'down';
  let rafId = null;
  let isInitialized = false;

  function applyTransform(item) {
    const currentX = item.startX * (1 - item.current);
    item.media.style.transform = `translateX(${currentX}%)`;
  }

  function initializeItems() {
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    items.forEach((item) => {
      const rect = item.wrapper.getBoundingClientRect();
      const initialProgress = getInitialProgress(rect, viewportHeight);

      item.current = initialProgress;
      item.target = initialProgress;

      item.media.style.willChange = 'transform';
      applyTransform(item);
    });

    isInitialized = true;
  }

  function updateTargets() {
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    items.forEach((item) => {
      const rect = item.wrapper.getBoundingClientRect();

      item.target = scrollDirection === 'up'
        ? getUpProgress(rect, viewportHeight)
        : getDownProgress(rect, viewportHeight);
    });
  }

  function render() {
    let shouldContinue = false;

    items.forEach((item) => {
      const diff = item.target - item.current;

      if (Math.abs(diff) > SNAP) {
        item.current += diff * SMOOTHING;
        shouldContinue = true;
      } else {
        item.current = item.target;
      }

      applyTransform(item);
    });

    return shouldContinue;
  }

  function tick() {
    rafId = null;

    if (!isInitialized) {
      initializeItems();
    }

    updateTargets();

    if (render()) {
      rafId = requestAnimationFrame(tick);
    }
  }

  function requestTick() {
    if (rafId) return;
    rafId = requestAnimationFrame(tick);
  }

  function onScroll() {
    const currentScrollY = window.pageYOffset || window.scrollY || 0;

    if (currentScrollY !== lastScrollY) {
      scrollDirection = currentScrollY < lastScrollY ? 'up' : 'down';
      lastScrollY = currentScrollY;
    }

    requestTick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', requestTick, { once: true });
  } else {
    requestTick();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', requestTick, { passive: true });
  window.addEventListener('orientationchange', requestTick, { passive: true });
  window.addEventListener('load', requestTick);
})();